export const windowObject = () => typeof window !== "undefined"